import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Headture, FinResource, FinResourceType } from "@app/definitions/types"
import { pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { PreviewFinresourceComponent } from "@app/preview-finresource/preview-finresource.component"
import { GetNextIdComponent } from "@app/get-next-id.component"
import { GetHeadtureRowComponent } from "@app/get-headture-row.component"

@Component({
	selector: "app-finresource-credit",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		LangValPipe,
		CancelBtnComponent,
		BtnExtComponent,
		PreviewFinresourceComponent,
		GetNextIdComponent,
		GetHeadtureRowComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (objectRow) {
			<div>
				<label>{{ "description" | langVal }}</label>

				<app-gen-input
					[actualObj]="objectRow"
					[errors]="errors"
					fieldName="description"
					(keyupEvent)="validateEntireForm()"
				>
				</app-gen-input>
			</div>

			<div>
				<label>{{ "remarks" | langVal }}</label>

				<app-gen-input
					[actualObj]="objectRow"
					[errors]="errors"
					fieldName="remarks"
					(keyupEvent)="validateEntireForm()"
				>
				</app-gen-input>
			</div>

			<div class="modal-btns">
				<app-cancel-btn (click)="onClose.emit()" />
				<app-btn-ext
					text="to_preview"
					[disabled]="!isFormSubmittable"
					(clickEv)="isGetIdOpen = true"
					[isSpin]="isGetIdOpen || isGetHeadtureOpen"
				/>
			</div>
		}
		@if (modalProps) {
			<app-preview-finresource
				(onClose)="modalProps = null; onClose.emit($event)"
				[headtureRow]="modalProps.headtureRow"
				[finresourceObj]="objectRow"
				[doctype]="objectRow.doctype"
			/>
		}
		@if (isGetIdOpen) {
			<app-get-next-id
				[doctype]="'credit_' + objectRow.doctype"
				(onDone)="handleId($event)"
			/>
		}

		@if (isGetHeadtureOpen) {
			<app-get-headture-row
				(onDone)="
					isGetHeadtureOpen = false; $event && handleGetHeadtureRow($event)
				"
			/>
		}
	`,
})
export class FinresourceCreditComponent extends Modalable {
	modalProps: any = null
	isGetIdOpen: boolean = false
	isGetHeadtureOpen: boolean = false

	headtureRow: Headture | null = null
	finresourceObj: FinResource | null = null
	@Input() objectRow: any = null
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		description: { not_empty: null },
	}
	async ngOnInit() {
		//get invoice
		const res: any = await this.apiService.post("get_finresource", {
			resource_type: this.objectRow.doctype,
			id: this.objectRow.id,
		})
		this.objectRow = { ...res, doctype: this.objectRow.doctype }
		this.objectRow.description =
			this.lang.getVal("credit_invoice_against") +
			this.lang.getVal(this.objectRow.doctype) +
			" " +
			this.objectRow.id +
			" " +
			this.lang.getVal("total_of") +
			" " +
			this.objectRow.total
		this.objectRow.remarks = ""
		this.validateEntireForm()
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.objectRow,
			this.errors,
			this.validationFields
		)
	}

	handleGetHeadtureRow(headtureRow: any) {
		this.objectRow.description_dec = this.objectRow.description
		this.objectRow.remarks_dec = this.objectRow.remarks

		this.objectRow.totalMinusvat = this.objectRow.totalMinusvat * -1
		this.objectRow.vat = this.objectRow.vat * -1
		this.objectRow.total = this.objectRow.total * -1
		this.objectRow.doctype = "credit_" + this.objectRow.doctype
		this.objectRow.payment_details = ""
		this.objectRow.created_at = ""
		this.objectRow.invoicelines = []

		this.modalProps = {
			headtureRow,
		}
	}
	async handleId(id: any) {
		this.isGetIdOpen = false
		if (!id) {
			return
		}
		this.objectRow.formerId = this.objectRow.id
		this.objectRow.id = id

		if (this.objectRow.doctype === "admininvoice") {
			this.handleGetHeadtureRow(null)
			return
		}
		this.isGetHeadtureOpen = true
	}
}
